import { apiClient } from './client';

export const submitEnquiry = async (data: {
  name: string;
  email: string;
  phone?: string;
  message: string;
}): Promise<{ message: string }> => {
  const response = await apiClient.post('/enquiries', data);
  return response.data;
};